// A small subsequence scorer for completions: "snr" finds "snare", "hhat"
// finds "hihat", "dnb" finds "Drum & Bass". Forty lines, no dependency, pure.
//
// Every character of the needle must appear in the hay, in order. Each
// matched character scores 1; one that follows the previous match scores 2
// more; one that begins a word (the start, or after anything that is not a
// letter or digit) scores 3 more; a match that starts at the very beginning
// scores 4 more. Unmatched hay costs a tenth per character, so the shorter
// of two hays that match alike wins. 0 means no match; a match is always
// positive.
//
// Greedy left-to-right, which is not always the best alignment — good
// enough for a list of eight, and predictable.

function isWordChar(c: string): boolean {
  return /[a-z0-9]/i.test(c);
}

export function fuzzyScore(needle: string, hay: string): number {
  const n = needle.toLowerCase();
  const h = hay.toLowerCase();
  if (n.length === 0 || h.length === 0 || n.length > h.length) return 0;
  let score = 0;
  let at = 0;
  let last = -2;
  for (const ch of n) {
    const i = h.indexOf(ch, at);
    if (i < 0) return 0;
    score += 1;
    if (i === last + 1) score += 2;
    if (i === 0 || !isWordChar(h[i - 1]!)) score += 3;
    if (last === -2 && i === 0) score += 4;
    last = i;
    at = i + 1;
  }
  score -= (h.length - n.length) * 0.1;
  return Math.max(score, 0.01);
}

/** The best score of a needle over several hays (0 when none match). */
export function fuzzyBest(needle: string, hays: readonly string[]): number {
  let best = 0;
  for (const h of hays) best = Math.max(best, fuzzyScore(needle, h));
  return best;
}
